// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"49501459","64":"a503b1e7","319":"87dd5950","364":"8962b211","443":"5cf17297","482":"d070088b","520":"bba9171d","591":"a00fab9d","807":"1c5f5bd1"}[chunkId] + ".chunk.js";
};